import { useOnline } from "@/app/online";
import { LoaderCircle, TriangleAlert, WifiOff } from "lucide-react";

export function ShellLoading() {
  return (
    <div className="shell-state">
      <LoaderCircle className="shell-state__spinner" size={28} aria-hidden="true" />
      <p className="t-body">Cargando tu perfil…</p>
    </div>
  );
}

export function ShellError({ message, onRetry }: { message: string; onRetry: () => void }) {
  const online = useOnline();

  return (
    <div className="shell-state">
      {online ? (
        <TriangleAlert size={28} aria-hidden="true" />
      ) : (
        <WifiOff size={28} aria-hidden="true" />
      )}
      <h2 className="t-h3">{online ? "No pudimos cargar tu perfil" : "Sin señal"}</h2>
      <p className="t-small">
        {online
          ? message
          : "El teléfono no tiene conexión. Buscá señal y volvé a intentar: no se perdió nada de lo que ya cargaste."}
      </p>
      <button type="button" className="btn btn--primary" onClick={onRetry}>
        Reintentar
      </button>
    </div>
  );
}
